import type { ReactNode } from 'react';
import classnames from 'classnames';
import * as styles from './Figure.module.scss';

export interface IFigureProps {
    alt: string;
    children?: ReactNode;
    className?: string;
    fixedSquareSizes?: 'is-16x16' | 'is-24x24' | 'is-32x32' | 'is-48x48' | 'is-64x64' | 'is-96x96' | 'is-128x128';
    imageRatio?:
        | 'is-square'
        | 'is-5by4'
        | 'is-4by3'
        | 'is-3by2'
        | 'is-5by3'
        | 'is-16by9'
        | 'is-2by1'
        | 'is-3by1'
        | 'is-4by5'
        | 'is-3by4'
        | 'is-2by3'
        | 'is-3by5'
        | 'is-9by16'
        | 'is-1by2'
        | 'is-1by3';
    // Use ratio when exact sizes are unknown
    imageUrl: string;
    imgClassName?: string;
}
export function Figure(props: IFigureProps) {
    const className = classnames(
        styles.figure,
        props.imageRatio ? `${props.imageRatio}` : '',
        props.fixedSquareSizes ? `${props.fixedSquareSizes}` : ''
    );

    return (
        <figure className={classnames(className, props.className || '')}>
            <img
                alt={props.alt}
                className={classnames(styles.image, props.imgClassName || '')}
                src={props.imageUrl}
            />
            {props.children && <div className={styles.imageCaption}>{props.children}</div>}
        </figure>
    );
}
